import { render, staticRenderFns } from "./comp-rooms.vue?vue&type=template&id=57e6f9e1&scoped=true&"
import script from "./comp-rooms.vue?vue&type=script&lang=js&"
export * from "./comp-rooms.vue?vue&type=script&lang=js&"
import style0 from "./comp-rooms.vue?vue&type=style&index=0&id=57e6f9e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e6f9e1",
  null
  
)

/* custom blocks */
import block0 from "./comp-rooms.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports